import ExportModal from './component';
import enhance from './container';

export default enhance(ExportModal);
